import { axiosCompanyPortalInstance } from "./";

const COMPANY_CLIENTS_PATH = "/company_clients";

/** GET /company_portal/v1/company_clients — list/search clients.
 * Pagination is returned via response headers (Current-Page, Page-Items,
 * Total-Count, Total-Pages). `name` does a case-insensitive partial match. */
const getCompanyClients = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(COMPANY_CLIENTS_PATH, { ...config, params });

/** GET /company_portal/v1/company_clients/:id — show a single client relationship. */
const getCompanyClient = (id) =>
  axiosCompanyPortalInstance.get(`${COMPANY_CLIENTS_PATH}/${id}`);

/** PATCH /company_portal/v1/company_clients/:id — update relationship fields. */
const updateCompanyClient = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`${COMPANY_CLIENTS_PATH}/${id}`, data);

/** POST /company_portal/v1/company_clients — invite a new client or link an
 * existing one by email. Use `client_email`, not `email`. */
const createCompanyClient = (data) =>
  axiosCompanyPortalInstance.post(COMPANY_CLIENTS_PATH, data);

export {
  getCompanyClients,
  getCompanyClient,
  updateCompanyClient,
  createCompanyClient,
};
